
const environments = [
    {
        name: "devt01",
        id: "c86c891f-3fc0-464f-a87f-68861010f1d8",
        qurl: "https://devt01-graph.asc-recording.dev/graphql",
        tld: "dev"
    },
    {
        name: "devt02",
        id: "93fcbeab-9c32-46ed-9af1-fbdbe9e49a09",
        qurl: "https://devt02-graph.asc-recording.dev/graphql",
        tld: "dev"
    },
    {
        name: "devt03",
        id: "7f1c5744-6628-4030-b90c-e1ef76d661bb",
        qurl: "https://devt03-graph.asc-recording.dev/graphql",
        tld: "dev"
    },
    {
        name: "devt04",
        id: "8a98e7ab-3fb2-4ef9-9b20-260262ceec33",
        qurl: "https://devt04-graph.asc-recording.dev/graphql",
        tld: "dev"
    },
    {
        name: "devt05",
        id: "3382526a-36b8-4f4b-aab9-23701b18f4ce",
        qurl: "https://devt05-graph.asc-recording.dev/graphql",
        tld: "dev"
    },
    {
        name: "devt06",
        id: "67b73680-e32f-4007-a317-0835cbc8d0ff",
        qurl: "https://devt06-graph.asc-recording.dev/graphql",
        tld: "dev"
    },
    {
        name: "devt07",
        id: "b24f40a5-b446-4a03-863d-95bc30b81b3f",
        qurl: "https://devt07-graph.asc-recording.dev/graphql",
        tld: "dev"
    },
    {
        name: "devt10",
        id: "0b0ea023-0f59-4311-b4eb-5009d227e78c",
        qurl: "https://devt10-graph.asc-recording.dev/graphql",
        tld: "dev"
    },
    {
        name: "devt14",
        id: "258e0196-3d13-4ae2-a135-a63ae2910998",
        qurl: "https://devt14-graph.asc-recording.dev/graphql",
        tld: "dev"
    },
    {
        name: "devt15",
        id: "962516d5-c9c8-4011-9f18-e9c744f8003e",
        qurl: "https://devt15-graph.asc-recording.dev/graphql",
        tld: "dev"
    },
    {
        name: "stage",
        id: "3fcf3b2d-7f84-410f-8a13-075ed7ce8c1e",
        qurl: "https://stage-graph.asc-recording.app/graphql",
        tld: "app"
    }
    // To run against a GraphqlApi on your own machine, uncomment this entry
    // and set LOCAL_ENV_NAME = "dev" in ini.js.The id is the AppId from
    // the local cluster manifest, which is an older app registration than the one
    // devt04 has above - that is why flipping LOCAL_USE_LOCAL_GRAPHQL on devt04 does
    // not authenticate. The name has to stay "dev" so the scope comes out as
    // api://dev-teams.asc-recording.app/<id>/user_impersonation.
    // ,{
    //     name: "dev",
    //     id: "f076e884-47e5-41c9-babd-9c583e0ddb98",
    //     qurl: "http://localhost:20001/graphql",
    //     tld: "app"
    // }
]

export const getEnvVariable = (name: string, localGraphql: boolean): { name: string, id: string, qurl: string, tld: string } => {
    const env = environments.find(e => e.name === name)
    if (env !== undefined) {
        console.log(`Using local environment: ${env.name} and localGraphql: ${(localGraphql ? "YES" : "NO")}`)
        if (localGraphql) {
            return { ...env, qurl: "http://localhost:20001/graphql" }
        } else {
            return env
        }
    }
    throw new Error(`Environment variable ${name} not found`)
}
